module.exports = __webpack_public_path__ + "static/media/desarrollo2.4cc5973d.png";